export const setMyIndex = (myIndex) => ({
	type: 'SET_MY_INDEX',
	myIndex,
});
